import { setTrackingIdRecord, TrackingIdRecords } from './general/utils/ga4-tracking/tracking-id-records.ts';
import { onIdleOrFirstInteraction } from './general/utils/utils';

(async () => {
  /** Set cookie "tippgeber" if tgid is defined in URL Params **/
  /**
   * Script for setting cookies based on URL parameters.
   *
   * @author [Your Name] <[your.email@example.com](mailto:your.email@example.com)>
   */

  // Set expiration date for cookie
  let date = new Date();
  date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000); // 1 year

  // Declare variables
  let tippgeber_id = ''; // Tippgeber ID
  let partner_id = ''; // Partner ID
  // Create tracking IDs array
  const trackingIds = Object.values(TrackingIdRecords).map(id => ({
    id,
    value: ''
  }));

  let voucherId = ''; // Voucher ID
  const expires = '; expires=' + date.toUTCString(); // Cookie expiration date

  // Check if 'tippgeber' is present in local storage and cookie
  let hasTippgeberInLocalStorage = false;
  try {
    hasTippgeberInLocalStorage = null === window.localStorage?.getItem('tippgeber') ? false : true;
  } catch {
    hasTippgeberInLocalStorage = false;
  }

  // cookieStore.set() throws if the value doesn't conform to RFC 6265 (e.g. unencoded UTF-8 or
  // reserved characters coming straight from a URL param) - fall back to document.cookie so a
  // malformed value doesn't break tracking cookies entirely.
  const setCookie = async (options, fallbackCookieString) => {
    if ('cookieStore' in window) {
      try {
        await cookieStore.set(options);
        return;
      } catch {
        // fall through to document.cookie
      }
    }
    document.cookie = fallbackCookieString;
  };

  const hasTippgeberInCookie = 'cookieStore' in window ? !!(await cookieStore.get('tippgeber')) : document.cookie.indexOf('tippgeber') > -1;
  // Get current URL
  const url = window.location.href;

  // Split URL parameters
  const splitString = url.indexOf('&amp;') > -1 ? '&amp;' : '&';
  const parameters = url.indexOf('?') > -1 ? url.split('?')[1].split(splitString) : '';

  // Object for storing URL parameters
  const parametersObject = {};

  /**
   * Set cookie domain based on hostname.
   *
   * @param {string} cookieDomain - The current hostname.
   * @return {void}
   */
  // Set cookie domain based on hostname
  let cookieDomain = window.location.hostname;
  if (cookieDomain.indexOf('ottonova.de') > -1) {
    cookieDomain = 'ottonova.de';
  } else if (cookieDomain.indexOf('on.ag') > -1) {
    cookieDomain = 'on.ag';
  }

  window.cookieDomain = cookieDomain;

  /**
   * Parse URL parameters and set cookies accordingly.
   *
   * @return {void}
   */
  if (parameters !== '') {
    // Iterate over URL parameters
    for (const index in parameters) {
      const parameterDetails = parameters[index].split('=');
      if (parameterDetails[0] && parameterDetails[1]) {
        // Store parameter details in an object
        parametersObject[parameterDetails[0]] = decodeURIComponent(parameterDetails[1]);
      }
    }

    let cookieValues = [];

    // Set cookie values based on parameter details
    if (parametersObject['utm_campaign']) {
      cookieValues.push('utmccn=' + parametersObject['utm_campaign']);
    }
    if (parametersObject['utm_content']) {
      cookieValues.push('utmcct=' + parametersObject['utm_content']);
    }
    if (parametersObject['utm_medium']) {
      cookieValues.push('utmcmd=' + parametersObject['utm_medium']);
    }
    if (parametersObject['utm_source']) {
      cookieValues.push('utmcsr=' + parametersObject['utm_source']);
    }
    if (parametersObject['utm_term']) {
      cookieValues.push('utmctr=' + parametersObject['utm_term']);
    }
    if (parametersObject['tgid']) {
      tippgeber_id = parametersObject['tgid'];
    }
    if (parametersObject['partnerid']) {
      partner_id = parametersObject['partnerid'];
    }
    trackingIds.forEach(item => {
      if (parametersObject[item.id]) {
        item.value = parametersObject[item.id];
      }
    });
    if (parametersObject['utm_void']) {
      voucherId = parametersObject['utm_void'];
    }
    if (parametersObject['utm_mvid']) {
      voucherId = parametersObject['utm_mvid'];
    }

    const cookieName = '__utmz';
    const cookieValue = cookieValues.join('|');

    // Set cookie if cookieValue is not empty
    if (cookieValue !== '') {
      await setCookie(
        {
          name: cookieName,
          value: cookieValue,
          expires: Date.now() + 365 * 24 * 60 * 60 * 1000, // 1 year
          domain: cookieDomain,
          path: '/'
        },
        cookieName + '=' + cookieValue + expires + '; path=/; domain=' + cookieDomain
      );
    }

    // Set tippgeber in localstorage or cookie if it is missing
    if (voucherId !== '') {
      window.localStorage?.setItem('mvid', voucherId);
    }
    if (partner_id && !window.localStorage?.getItem('partner')) {
      window.localStorage?.setItem('partner', partner_id);
    }
    if (!hasTippgeberInLocalStorage && !hasTippgeberInCookie && tippgeber_id !== '') {
      window.localStorage?.setItem('tippgeber', tippgeber_id);
      await setCookie(
        {
          name: 'tippgeber',
          value: tippgeber_id,
          expires: Date.now() + 365 * 24 * 60 * 60 * 1000, // 1 year
          domain: cookieDomain
        },
        'tippgeber=' + tippgeber_id + expires + '; path=/; secure; domain=' + cookieDomain
      );
    }
  }
  /**
   * Sets tippgeber in localstorage or cookie if it is missing.
   * It checks if tippgeber exists in localstorage, if it does,
   * it sets the id in cookie. If it doesn't, it checks if it exists in cookie,
   * if it does, it sets the id in localstorage.
   */
  if (hasTippgeberInLocalStorage) {
    // Get tippgeber id from localstorage
    tippgeber_id = window.localStorage?.getItem('tippgeber');
    // Set tippgeber id in cookie
    await setCookie(
      {
        name: 'tippgeber',
        value: tippgeber_id,
        expires: Date.now() + 365 * 24 * 60 * 60 * 1000, // 1 year
        domain: cookieDomain,
        path: '/'
      },
      'tippgeber=' + tippgeber_id + expires + '; path=/; secure; domain=' + cookieDomain
    );
  } else if (hasTippgeberInCookie) {
    // Check if tippgeber id exists in cookie
    let tippgeberCookieValue = false;
    if ('cookieStore' in window) {
      const tippgeberCookie = await cookieStore.get('tippgeber');
      tippgeberCookieValue = tippgeberCookie && tippgeberCookie.value ? tippgeberCookie.value : false;
    } else {
      const cookieMatch = document.cookie.match('(?:^|; )tippgeber=([^;]*)');
      // Get tippgeber id from cookie if it exists
      tippgeberCookieValue = cookieMatch && cookieMatch[1] ? cookieMatch[1] : false;
    }
    if (tippgeberCookieValue) {
      // Set tippgeber id in localstorage
      tippgeber_id = tippgeberCookieValue;
      window.localStorage?.setItem('tippgeber', tippgeberCookieValue);
    }
  }

  // Set tracking ids
  trackingIds.forEach(item => {
    setTrackingIdRecord(item.id, item.value);
  });

  //Detect old operating systems
  const agent = window.navigator.userAgent;
  if (agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) {
    const versionString = agent.match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (versionString) {
      const version = [parseInt(versionString[1], 10), parseInt(versionString[2], 10), parseInt(versionString[3] || 0, 10)];
      if (version[0] <= 9) {
        window.location.href = `${window.location.origin}/unsupported_os`;
      }
    }
  }

  /** NOT FULLY SUPPORTED BY SAFARI therefore ->
   * window.requestIdleCallback()
   * version 0.0.0
   * Browser Compatibility:
   * https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback#browser_compatibility
   */

  if (!window.requestIdleCallback) {
    window.requestIdleCallback = function (callback, options) {
      const newOptions = options || {};
      const relaxation = 1;
      const timeout = newOptions.timeout || relaxation;
      const start = performance.now();
      return setTimeout(function () {
        callback({
          get didTimeout() {
            return newOptions.timeout ? false : performance.now() - start - relaxation > timeout;
          },
          timeRemaining: function () {
            return Math.max(0, relaxation + (performance.now() - start));
          }
        });
      }, relaxation);
    };
  }

  /** GTM Load **/
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }

  if (cookieDomain !== 'localhost' && !window.Cypress) {
    onIdleOrFirstInteraction(() => {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js',
          page_insurance_group: window.craftConfig.insuranceGroup || 'na',
          page_insurance_category: window.craftConfig.insuranceCategory || 'na',
          page_artifacts: 'craft',
          page_artifacts_grouping: window.craftConfig.pageArtifactsGroup,
          page_funnel_position: window.craftConfig.pageFunnelPosition,
          page_funnel_detail: window.craftConfig.pageFunnelDetail
        });
        const f = d.getElementsByTagName(s)[0],
          j = d.createElement(s);
        j.async = true;
        j.src = 'https://www.ottonova.de/metrics/devu9bjwwtbwg.js?' + i;
        const n = d.querySelector('[nonce]');
        n && j.setAttribute('nonce', n.nonce || n.getAttribute('nonce'));
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 't=DhNfMyM6RzI9PChGMT1MFFpFTEVREwRfEAAVWhgDHg0JGBQVWRMPRBQYEklYGg8WFR4BBw%3D%3D');
    });
  }

  if (window.location.pathname !== '/zahnzusatz-abschliessen') {
    // Send Page view event
    window.addEventListener('DOMContentLoaded', () => {
      const navigationEntry = performance.getEntriesByType('navigation')[0];
      const textFragments = navigationEntry?.name?.split(':~:text=')[1];
      dataLayer.push({
        event: 'virtual_pageview',
        page_insurance_group: window.craftConfig.insuranceGroup || 'na',
        page_insurance_category: window.craftConfig.insuranceCategory || 'na',
        page_artifacts: 'craft',
        page_artifacts_grouping: window.craftConfig.pageArtifactsGroup,
        page_funnel_position: window.craftConfig.pageFunnelPosition,
        page_funnel_detail: window.craftConfig.pageFunnelDetail,
        page_location: window.location.href,
        page_title: document.title,
        ...(textFragments && { text_fragments: decodeURI(textFragments) })
      });
    });
  }
})();
